import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import { NavLink } from 'react-router-dom';
import Validate from 'app/validation/validation';

import { signupForNewsletter, updateUserData } from '../../../redux/actions';

import './footerNewsletterForm.scss';
//assets
import submit_footer from 'assets/icons/submit_footer.svg';
import cb_empty from 'assets/icons/cb_empty.svg';
import cb_checked from 'assets/icons/cb_checked.svg';
import {getMediaPath, reactParserCommonOptions} from "../../../app/functions";
import AnalyticsManager from "../../../app/analytics";
import ReactHtmlParser from "react-html-parser";


class FooterNewsletterForm extends Component{

    constructor(props){
        super(props);

        this.state = {
            first_try: true,
            form: {
                personalId: {
                    val: '',
                    valid: false,
                    rules: ['not_empty', 'id'],
                    errMsg: '',
                },
                email: {
                    val: '',
                    valid: false,
                    rules: ['not_empty', 'email'],
                    errMsg: '',
                },
                cellphone: {
                    val: '',
                    valid: false,
                    rules: ['cell_optional'],
                    errMsg: '',
                },
            },
            condition: {
                checked: true,
                errMsg: 'יש לאשר את התקנון',
            },
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCheckboxOnClick = this.handleCheckboxOnClick.bind(this);
    }

    componentDidMount() {
        this.adjustFormBasedOnUserData();
    }

    componentDidUpdate(prevProps) {
        const { userData } = this.props;

        if (userData !== prevProps.userData) {
            this.adjustFormBasedOnUserData();
        }
    }

    adjustFormBasedOnUserData() {
        const { userData } = this.props;

        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                personalId: {
                    ...this.state.form.personalId,
                    // Field is displayed only to non-logged-in users
                    rules: userData ? [] : ['not_empty', 'id'],
                },
                fullname: {
                    ...this.state.form.fullname,
                    // Field is displayed only to non-logged-in users
                    rules: userData ? [] : ['not_empty'],
                },
                email: {
                    ...this.state.form.email,
                    val: userData ? userData.email : '',
                },
                cellphone: {
                    ...this.state.form.cellphone,
                    val: userData ? userData.phone : '',
                },
            },
        });
    }

    handleSubmit(e) {
        AnalyticsManager.logSubscribeToNewsletterEvents();
        e.preventDefault();
        let form_valid = true;
        let new_state = this.state.form;

        for(let field in this.state.form) {
            let validate = Validate(this.state.form[field].val, this.state.form[field].rules);
            let is_valid = validate.valid;
            let msg = validate.msg;

            new_state[field].valid = is_valid;
            new_state[field].errMsg = msg;

            if(is_valid === false) {
                form_valid = false;
            }
        }
        this.setState({form:new_state, first_try:false});

        // AnalyticsManager.logSubscribeToNewsletter();


        if (form_valid && this.state.condition.checked) {
            const { userData } = this.props;
            let payload = {};
            for (let key in this.state.form) {
                payload[key] = this.state.form[key].val;
            }
            if (userData) {
                payload.fullname = userData.first_name + " " + userData.last_name;
                payload.personalId = userData.user_id;
            }

            this.props.subscribe(payload);

            // Log success event
            AnalyticsManager.logSubscribeToNewsletterSuccess();
        } else {
            AnalyticsManager.logSubscribeToNewsletterFailed();
        }
    }

    handleInputChange(e){
        const name = e.target.name;
        const val = e.target.value.trim();

        let validate = Validate(val, this.state.form[name].rules);
        let is_valid = validate.valid;
        let msg = validate.msg;
        let new_state = {...this.state.form,[name]: {...this.state.form[name], val:val, valid:is_valid, errMsg:msg}};
        this.setState({form:new_state});
    }

    handleCheckboxOnClick(){
        const check = !this.state.condition.checked;
        this.setState({condition: {...this.state.condition,checked:check}});
    }

    render(){
        const isSubscribe = this.props.isSubscribe;
        const {
            className = '',
            checkbox_id,
            show_img = false,
            userData,
            text,
        } = this.props;

        const showErrorMsg = !this.state.first_try && (
            !this.state.form.personalId.valid ||
            !this.state.form.email.valid ||
            !this.state.form.cellphone.valid
        );
        const showErrorCB = !this.state.first_try && !this.state.condition.checked;
        const dismissMenu = this.props.dismissMenu ? this.props.dismissMenu : () => {};

        return (
            <form id="footer-newsletter" className={'news-latter ' + className} onSubmit={this.handleSubmit}>
                {!isSubscribe &&
                    <Fragment>
                        <span className='label'>{text['marketing_footer_title']}</span>
                        <div className='mail-wrapper'>
                            {!userData && (
                                <div className='input-wrapper'>
                                    <input className='input-element'
                                           type='text'
                                           name='personalId'
                                           placeholder={text['marketing_personal_id_field']}
                                           aria-label={text['marketing_personal_id_field']}
                                           value={this.state.form.personalId.val}
                                           onChange={this.handleInputChange}/>
                                    {showErrorMsg ? <div className='error-msg'>{this.state.form.personalId.errMsg}</div> : ''}
                                </div>
                            )}
                            <div className='input-wrapper'>
                                <input className='input-element'
                                       type='text'
                                       name='email'
                                       placeholder={text['marketing_email_field']}
                                       aria-label={text['marketing_email_field']}
                                       value={this.state.form.email.val}
                                       onChange={this.handleInputChange}/>
                                {showErrorMsg ? <div className='error-msg'>{this.state.form.email.errMsg}</div> : ''}
                            </div>
                            <div className='input-wrapper'>
                                <input className='input-element'
                                       type='text'
                                       name='cellphone'
                                       placeholder={text['marketing_cellphone_field']}
                                       aria-label={text['marketing_cellphone_field']}
                                       value={this.state.form.cellphone.val}
                                       onChange={this.handleInputChange}/>
                                {showErrorMsg ? <div className='error-msg'>{this.state.form.cellphone.errMsg}</div> : ''}
                            </div>
                            <div className='cb-wrapper' onClick={this.handleCheckboxOnClick}>
                                <img className='cb-img' src={this.state.condition.checked ? getMediaPath(cb_checked) : getMediaPath(cb_empty)} alt='' />
                                <input id={checkbox_id}
                                       type='checkbox'
                                       className='cb'
                                       name='conditions'
                                       disabled
                                       aria-label="מסכים לתנאי השימוש" />
                                <label htmlFor={checkbox_id} >
                                    <span onClick={e => {
                                        if(e) {
                                            e.stopPropagation();
                                        }
                                    }}>{ ReactHtmlParser(text['web_newsletter_agreemnet'], reactParserCommonOptions()) }</span>
                                    <NavLink onClick={ dismissMenu } to= {"/" + this.props.policy_page_url } className="link">
                                        { this.props.text.web_to_policy }
                                    </NavLink>
                                </label>

                                {showErrorCB ? <div className='error-msg'>{this.state.condition.errMsg}</div> : ''}
                            </div>
                            <div className='submit-wrapper'>
                                <button className='submit-btn'
                                        type='submit'
                                        name="submit"
                                        value=''
                                        aria-label="שלח"></button>
                                {show_img ? <img className='mail-img' src={getMediaPath(submit_footer)} alt='/'/> :
                                    <span className='submit-span'>{text['marketing_footer_submit_button']}</span>}
                            </div>
                        </div>
                    </Fragment>
                }
                {isSubscribe &&
                    <Fragment>
                        <div className='success'>{ this.props.text.web_newsletter_success }</div>
                    </Fragment>
                }
            </form>
        );
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        userData: store.config.UserData,
        text: store.config.Translations,
        isSubscribe: store.data.Newsletter_subscribe,
        policy_page_url: store.data.policy_page_id,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        subscribe: (payload, afterSuccess) => dispatch(signupForNewsletter(payload, afterSuccess)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(FooterNewsletterForm);
